import Button from "@components/Button"
import Layout from "@components/Layout"
import Mascot, { MascotState } from "@components/Mascot"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

interface Props {
  translationKey: string
  placeholder: string
  /** @deprecated No longer used in Yazio-style design */
  backgroundImage?: string
}

export default function NumberInputPage({
  translationKey,
  placeholder,
}: Props) {
  const { t } = useTranslation()
  const [value, setValue] = useState("")
  const [mascotState, setMascotState] = useState<MascotState>("idle")

  useEffect(() => {
    if (value.length > 0) {
      setMascotState("writing")
      const timer = setTimeout(() => setMascotState("idle"), 600)
      return () => clearTimeout(timer)
    }
  }, [value])

  const heading = t(`pages.onboarding.${translationKey}.heading`)
  const subtitle = t(`pages.onboarding.${translationKey}.info`)

  return (
    <Layout>
      <div className="mt-4 flex items-center gap-3">
        <Mascot state={mascotState} />
        <div className="speech-bubble flex-1">
          <h1 className="text-lg font-bold">{heading}</h1>
        </div>
      </div>

      {subtitle && <p className="custom-subheading mt-3">{subtitle}</p>}

      <Form method="post" className="custom-form">
        <div className="mt-8 flex grow flex-col items-center justify-center space-y-5">
          <input
            type="number"
            name={translationKey}
            placeholder={placeholder}
            value={value}
            autoFocus
            onChange={(e) => setValue(e.target.value)}
            className="custom-input no-spinners mx-auto max-w-xs"
          />
        </div>
        <div className="sticky bottom-0 -mx-5 bg-gradient-to-t from-white from-70% to-transparent px-5 pt-8 pb-4">
          <Button
            title={t("shared.continue")}
            type="submit"
            disabled={value.trim() === ""}
          />
        </div>
      </Form>
    </Layout>
  )
}
